import React, { Component } from "react";
import { connect } from "react-redux";
import { refreshOfferTimeout, resetOfferTimeout, callTimeoutAction } from "../actions";
import { $, getRedirectAddressAfterTimeout } from "../shared/utils";
import { sessionTimeout } from "../shared/mocks/modal-search-timed-out";
import moment from "moment";
import tingle from "tingle.js";

let timeout;
let modal = {};

class SessionTimeWrapper extends Component {
	constructor() {
		super();
		this.mounted = false;
		this.state = { timeoutDate: null, timedOutAction: false };
	}

	componentDidMount() {
		if (!this.props.stopRender) {
			this.mounted = true;
			timeout = undefined;
		}
	}

	componentWillUpdate(nextProps) {
		if (nextProps.timedOutAction) {
			this.timeoutModal();
		}
	}

	componentDidUpdate(prevProps) {
		if (timeout == undefined) {
			this.outputTimeout();
		}

		if (prevProps.timedOutAction !== this.props.timedOutAction) {
			this.setState({ timedOutAction: this.props.timedOutAction });
		}
	}

	componentWillUnmount() {
		this.mounted = false;
		this.props.resetOfferTimeout();
		clearInterval(timeout);
	}

	timeoutModal() {
		if (!modal.isOpen) {
			modal = new tingle.modal({
				footer: false,
				closeMethods: [],
				onOpen: function() {
					$("#btn-try-purchase-again").onclick = e => {
						e.preventDefault();
						modal.isOpen = false;
						window.location.href = getRedirectAddressAfterTimeout();
						modal.destroy();
					};
				}
			});

			modal.isOpen = true;

			modal.setContent(sessionTimeout);
			modal.open();
		}
	}

	outputTimeout() {
		if (
			(this.props !== undefined && this.props.airlinesFetched && this.props.expireDate == "") ||
			new Date(this.props.expireDate) == "Invalid Date"
		) {
			this.props.refreshOfferTimeout();
			return;
		}

		const then = new Date(this.props.expireDate);

		let timeoutDate, outputDate;

		if (timeout == undefined) {
			timeout = setInterval(() => {
				if (Date.now() < then.getTime()) {
					timeoutDate = moment
						.utc(
							moment(then, "DD/MM/YYYY HH:mm:ss").diff(moment(new Date(), "DD/MM/YYYY HH:mm:ss"))
						)
						.format("mm:ss");
					outputDate = `${timeoutDate.split(":")[0]}:${timeoutDate.split(":")[1]}`;
					if (this.mounted) this.setState({ timeoutDate: outputDate });
				} else {
					clearInterval(timeout);

					this.props.callTimeoutAction();

					if (this.mounted) this.setState({ timeoutDate: null });
				}
			}, 1000);
		}
	}

	render() {
		const { timeoutDate, timedOutAction } = this.state;

		if (timedOutAction) {
			return (
				<div className="session-time">
					<span className="text">O tempo de sessão expirou.</span>
				</div>
			);
		} else {
			return (
				<div className="session-time">
					<i className="icon-clock" />
					<span className="text hidden-xs hidden-sm">Duração da oferta:</span>
					<span className="time">{timeoutDate !== null ? timeoutDate : "00:00"}</span>
				</div>
			);
		}
	}
}

const mapStateToProps = state => ({
	airlinesFetched: state.searchStatus.progress == 100,
	expireDate: state.offerTimeout.expireDate,
	timedOutAction: state.offerTimeout.timedOutAction,
	stopRender: state.offerTimeout.expireDate == "locked"
});

const mapDispatchToProps = dispatch => ({
	refreshOfferTimeout: () => dispatch(refreshOfferTimeout()),
	resetOfferTimeout: () => dispatch(resetOfferTimeout()),
	callTimeoutAction: () => dispatch(callTimeoutAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeWrapper);
